module.exports = __webpack_public_path__ + "media/images/noimage-user@2x-11d5f97ffaeb7175c08f292f1eaf6789.png";